const connectRoutes = [
	// Regex groups: addonKey, pageKey
	/\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i,
];

export default connectRoutes;
